var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDropbox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    height: "24px",
    width: "24px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "-271 282 256 238",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "-271,414.5 -195.7,463.6 -143,419.7 -218.9,372.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "-195.7,282 -271,331.1 -218.9,372.8 -143,325.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "-15,331.1 -90.3,282 -143,325.9 -67.1,372.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "-143,419.7 -90.3,463.6 -15,414.5 -67.1,372.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "-142.8,429.1 -195.7,473 -218.3,458.2 -218.3,474.8 -142.8,520 -67.4,474.8 -67.4,458.2 -90,473  "
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropbox);
export default __webpack_public_path__ + "static/media/dropbox.2ff5c9c22ab683ed49fac0032e5a6c07.svg";
export { ForwardRef as ReactComponent };